import { render, staticRenderFns } from "./UcProductMiniCard.yaml?vue&type=template&id=1cfdbdcb&component"
import script from "./UcProductMiniCard.yaml?vue&type=script&lang=ts&component"
export * from "./UcProductMiniCard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports